import LegalPage from "./LegalPage";
export default function Privacy() { return <LegalPage endpoint="/legal/privacy" title="Privacy Policy" />; }
